import { createSlice } from '@reduxjs/toolkit'

import { fetchConfigurationsAction } from '../actions/configurations'
import { ActionStatus } from '../types/Input'

export type ConfigurationKey =
  | 'phoneKuljettajienTukipalvelu'
  | 'punctualityStatisticsPowerBiLink'
  | 'lahiVeksiLink'
  | 'veksiLink'
  | 'majorIncidentFeedbackLink'
  | 'locomotiveTowingInstructionsLink'
  | 'backupTimetableLink1'
  | 'backupTimetableLink2'
  | 'googleCalendarLink'
  | 'outlookLink'
  | 'calendarInstructionsLink'
  | 'energyEfficiencyReportLink'
  | 'evolverFeedbackEmail'
  | 'backupCompositionLink'
  | 'phoneCommuterTekv'
  | 'phoneHenkilokuntaTukipalvelu'
  | 'kaukoliikenteenIlmoitustauluLink'

export type Configurations = Partial<Record<ConfigurationKey, string>>

export interface ConfigurationsState {
  data: Configurations
  status: ActionStatus
  error?: string
}

const initialState: ConfigurationsState = {
  data: {},
  status: 'none',
}

export const configurationsSlice = createSlice({
  name: 'configurations',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchConfigurationsAction.pending, (state) => {
      state.status = 'loading'
      state.error = undefined
    })

    builder.addCase(fetchConfigurationsAction.fulfilled, (state, { payload }) => {
      state.data = payload.reduce<Configurations>((accumulator, current) => {
        accumulator[current.key as ConfigurationKey] = current.value
        return accumulator
      }, {})
      state.status = 'succeeded'
      state.error = undefined
    })

    builder.addCase(fetchConfigurationsAction.rejected, (state, { payload }) => {
      state.status = 'failed'
      if (payload) {
        state.error = payload.message
      }
    })
  },
})

export default configurationsSlice.reducer
